//
// HelpProvider
//
// Display help info when in help mode
//
//

import PropTypes from 'prop-types';
import {
  // useState,
  useCallback,
  useRef,
  useMemo,
  useReducer,
} from 'react';

import {
  displayJson,
  disabledClicks,
} from '../../utils';

import HelpContext from './HelpContext';

// import {
// //   config,
//   displayJson,
// } from '../../utils';
const nd = 'Non disponible dans cette simulation. ';
const helpStrings = {
  help: 'Cliquer pour demander de l\'aide concernant des éléments de l\'interface.',
  home: 'Retour au menu principal.',
  privacy: `${nd}Désactive le suivi de position automatique.`,
  flashlight: `${nd}Contrôle la lampe du téléphone.`,
  search: `${nd}Recherche dans tous les éléments: messages, contacts, biens, alertes, menus.`,
  mute: `${nd}Contrôle le volume sonore de l'application.`,
  emergency: 'Signale aux services de secours un besoin d\'attention immédiate.',
  menuDisabled: `${nd}Essayez une autre catégorie...`,
  caseAddChat: `${nd}Commencer une discussion séparée avec un des organismes de secours actifs sur ce dossier.`,
  selChat: 'Sélectionner cette discussion.',
  casePage: 'Ouvre la page correspondant à l\'alerte en cours.',
  editCase: 'Modifier, partager ou fermer ce dossier.',
  menusettings: `${nd}Réglages et préférences.`,
  emergencyTelephone: `${nd}Déclenche un appel téléphonique vers ce numéro.`,
  openTray: 'Afficher / masquer plus de boutons de contrôle.',
  settings: 'Modifier les réglages de cette application.',
  hangup: 'Terminer l\'appel en cours.',
  speaker: 'Activer le haut-parleur du téléphone.',
  sendInfo: 'Envoyer les information récoltées.',
  // menuroad: `${nd}Incidents routiers.`,
  // menuthreat: `${nd}`,
  // menufireDept: `${nd}`,
  // menuwound: `${nd}`,
  // menumental: `${nd}`,
  // menupain: `${nd}`,
  // menubreathing: `${nd}`,
  // menupoison: `${nd}`,
  // menuqrScan: `${nd}`,
  network: `${nd}Urgence affectant une connaissance ou un proche.`,
  menubelongingsEmergency: `${nd}Urgence affectant un bien.`,
  menupast: `${nd}Dossiers passés (fermés ou mis en pause).`,
  menureport: 'Signalements ne nécessitant pas une intervention immédiate.',
  parentcategory: 'Sélectionner une catégorie précédente.',
  share: 'Partager l\'alerte anonymement avec ses proches ou son entourage.',
  terminate: 'Clôre cette alerte.',
  discussDrawer: 'Accéder à la liste des discussions disponibles.',
  messagingAdd: 'Créer une nouvelle discussion.',
  messagingEdit: 'Modifier cette discussion.',
  messagingDelete: 'Supprimer cette discussion.',
  maplocation: 'Définir l\'emplacement ou la direction vers laquelle se situe l\'incident',
  mapuser: 'Recentrer la carte autour de l\'emplacement de l\'utilisateur',
  imgClr: 'Effacer l\'image sélectionnée',
  imgCrop: 'Recadrer la photo sélectionnée',
  imgRot: 'Pivoter l\'image sélectionnée',
  papersManage: `${nd}Gérer mes pièces d'identité, documents officiels, cartes de paiements, etc...`,
  valuablesManage: `${nd}Garder un inventaire photographique de mes biens précieux.`,
  qrManage: `${nd}Créer, supprimer, assigner des codes Qr.`,
  btManage: `${nd}Gérer mes objets ou puces antivol bluetooth.`,
  qrInvite: `${nd}Inviter un autre utilisateur à joindre son réseau en utilisant un Qr code.`,
  dependantsdelegateChild: `${nd}Confier temporairement la responsabilité d'un dépendant à un tiers.`,
  dependantsmessaging: `${nd}Débuter une conversation avec cette personne.`,
  dependantsparentalControl: `${nd}Définir les conditions d'accès à internet: horaires, autorisation/interdiction temporaire.`,
  dependantsemergency: `${nd}Créer une alerte concernant cette personne.`,
  reportAbuse: 'Signaler un comportement abusif dans le traitement de ce problème.',
  endCase: 'Fermer ce dossier',

  noHelp: '',
};

const initialState = {
  helpOn: false,
  popupInfo: undefined,
};

const stateReducer = (helpOnRef) => (state, action) => {
  // console.log(`HelpStore stateReducer state=${
  //   displayJson(state)} action=${displayJson(action)}`);

  switch (action.type) {
    case 'setHelpOn': {
      if (state.helpOn === action.helpOn) return state;
      // eslint-disable-next-line no-param-reassign
      helpOnRef.current = action.helpOn;
      return {
        ...state,
        helpOn: action.helpOn,
      };
    }

    case 'setPopupInfo': {
      if (state.popupInfo === action.popupInfo) return state;
      return {
        ...state,
        popupInfo: action.popupInfo,
      };
    }

    case 'exitHelp': {
      if ((!state.popupInfo) && (!state.helpOn) && (!helpOnRef.current)) return state;
      // eslint-disable-next-line no-param-reassign
      helpOnRef.current = false;
      return initialState;
    }

    default:
      throw new Error(`helpStore stateReducer action=${displayJson(action)}`);
  }
};

function HelpProvider(props) {
  const {
    children,
  } = props;
  // Keep two copies of helpOn, so that helpOnClick never changes
  const helpOnRef = useRef(false);
  const [state, dispatch] = useReducer(stateReducer(helpOnRef), initialState);

  const setHelpOn = useCallback(
    (value) => {
      dispatch({ type: 'setHelpOn', helpOn: value, src: 'setHelpOn' });
    },
    [],
  );

  const helpOnClick = useCallback(
    (originalOnClick, helpString, notAvailable = false) => (event) => {
      //
      // originalOnClick: function to call if no help is displayed
      // helpString: help string reference
      // notAvailable: disable function calls, notAvailable display help message
      //
      // console.log(`helpOnClick notAvailable=${notAvailable} helpOn=${
      //   helpOnRef.current} helpString=${helpString}`);
      const newPopupInfo = {
        x: event.clientX,
        y: event.clientY,
      };
      let runOnClick = (!!originalOnClick);

      if (helpOnRef.current) {
        // Help is active, disable clicks, display help message
        console.log(`Help active, ignore click on "${helpString}"`);
        runOnClick = false;
        newPopupInfo.text = helpStrings[helpString] || `Pas d'aide disponible (code:${helpString})`;
      } else if (notAvailable || (helpString && disabledClicks.includes(helpString))) {
        // This click should always be disabled
        console.log(`Always ignore click on ${helpString}`);
        runOnClick = false;
        newPopupInfo.text = helpStrings[helpString] || nd;
      }

      if (runOnClick) {
        // console.log(`Propagate click on ${helpString}`);
        originalOnClick(event);
      }
      if (newPopupInfo.text) {
        dispatch({ type: 'setPopupInfo', popupInfo: newPopupInfo });
        // console.log(`setPopupInfo newPopupInfo=${JSON.stringify(newPopupInfo)}`);
      }
    },
    [dispatch],
  );

  // useState(
  //   () => { console.log(`help popupInfo=${displayJson(state.popupInfo)}`); },
  //   [state.popupInfo],
  // );

  const closePopup = useCallback(
    () => {
      dispatch({ type: 'exitHelp' });
    },
    [],
  );

  const contextValue = useMemo(
    () => ({
      help: {
        on: state.helpOn,
        setOn: setHelpOn,
        onClick: helpOnClick,
        popupInfo: state.popupInfo,
        closePopup,
        ready: true,
      },
    }),
    [closePopup, helpOnClick, setHelpOn, state.helpOn, state.popupInfo],
  );

  return (
    <HelpContext.Provider value={contextValue}>
      {children}
    </HelpContext.Provider>
  );
}

HelpProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HelpProvider;
